import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { ChannelsActions } from './channels.actions';
import { IChannelsState } from './channels.state';

export const initialChannelsState: IChannelsState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const channelsReducerFn = createReducer(
  initialChannelsState,
  on(ChannelsActions.reset, (state: IChannelsState, action) => {
    return new StateBuilder<IChannelsState>(initialChannelsState).build();
  }),
  on(ChannelsActions.load, (state: IChannelsState, action) => {
    return new StateBuilder<IChannelsState>(state).toLoading().build();
  }),
  on(ChannelsActions.loadSuccess, (state: IChannelsState, action) => {
    return new StateBuilder<IChannelsState>(state, action).toLoaded().build();
  }),
  on(ChannelsActions.submit, (state: IChannelsState, action) => {
    return new StateBuilder<IChannelsState>(state, action).toLoading().build();
  }),
  on(ChannelsActions.submitSuccess, (state: IChannelsState, action) => {
    return new StateBuilder<IChannelsState>(state, action).toLoaded().build();
  })
);

export function channelsReducer(state: IChannelsState | undefined, action: Action) {
  return channelsReducerFn(state, action);
}
